import { Called } from "../../../modules/calleds/types";
import api from "../api-instance";

const ROUTE = "/Calleds";

export async function postCreateCalled(
  name: string,
  email: string,
  calledCategory: number,
  descricao: string,
  anexos?: File[] | null
): Promise<Called> {
  const formData = new FormData();
  formData.append("Name", name);
  formData.append("Email", email);
  formData.append("Categoria", calledCategory.toString());
  formData.append("Descricao", descricao);
  if (anexos) {
    for (let i = 0; i < anexos.length; i++) {
      formData.append("Anexos", anexos[i]);
    }
  }

  const result = await api.post(`${ROUTE}/create`, formData);
  return result.data.called;
}
